export default {
  costingList: {
    method: 'post',
    url: '/client/costing/list'
  },
  getCostingDetail: {
    method: 'get',
    url: '/client/costing/detail/ID'
  },
  updateCosting: {
    method: 'put',
    url: '/client/costing/update/ID'
  },
  deleteCosting: {
    method: 'DELETE',
    url: '/client/costing/delete/ID'
  },
  archiveCosting: {
    method: 'DELETE',
    url: '/client/costing/archive'
  },
  restoreCosting: {
    method: 'PUT',
    url: '/client/costing/restore'
  }
}
